import React, { Suspense } from "react";

const ComponentSuspense = ({ children }) => {
  return <Suspense fallback={<></>}>{children}</Suspense>;
};

export default ComponentSuspense;
